<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
     <el-breadcrumb-item>
        <span class="page-title">存币生息</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>项目列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getList"></create>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters } from 'vuex';
import List from './components/list';
import Create from './components/create';

export default {
  name: 'PledgeInterest',
  data() {
    return {};
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('pledgeInterest', ['pagination']),
    ...mapGetters('pledgeInterest', ['list'])
  },
  methods: {
    ...mapActions('pledgeInterest', ['reqList', 'getCoinTypes']),
    getList(data = {}) {
      this.reqList({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
    this.getCoinTypes();
  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}
</style>
